/**
 * Concord CRM - https://www.concordcrm.com
 *
 * @version   1.6.0
 *
 * @link      Releases - https://www.concordcrm.com/releases
 * @link      Terms Of Service - https://www.concordcrm.com/terms
 *
 * @copyright Copyright (c) 2022-2025 KONKORD DIGITAL
 */
export const DEFAULT_STOP = 500

export const DEFAULT_STOPS = [
  0, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950, 1000,
]

export const SHADES = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900]

export const DEFAULT_PALETTE_CONFIG = {
  value: ``,
  valueStop: DEFAULT_STOP,
  swatches: [],
  h: 0, // hue
  s: 0, // saturation
  lMin: 0,
  lMax: 100,
  useLightness: true,
}
